import { PropsWithChildren, useMemo, useState } from "react";
import AuthContext, { AuthContextType } from "./context.";
import PrivateUser from "../dtos/user";

export default function AuthProvider({
  children,
  initial,
}: PropsWithChildren<{ initial: string | null }>) {
  const [user, setUser] = useState<PrivateUser | null>(null);
  const contextValue = useMemo((): AuthContextType => [user, setUser], [user]);

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}
